/*
 * @Descripttion:
 * @version:
 * @Author: sueRimn
 * @Date: 2023-10-17 11:07:16
 * @LastEditors: sueRimn
 * @LastEditTime: 2024-08-21 14:42:26
 */
import request from '@/utils/request'
import type * as log from '@/typings/log'
import type { CommonRes } from '@/typings'
import type { ILogPmListType } from '@/typings/log'

export interface LogProjectParams {
  project_name?: string
  circle_code?: string
  channel_id?: number
  event_mark?: number
  process_step?: number
  log_ctime_start?: string
  log_ctime_end?: string
  page?: number
  size?: number
}

// 表格数据
export async function getLogProjectList(params: LogProjectParams) {
  return request('/api/v2/project/log/search_my_log_list', {
    method: 'post',
    data: params
  })
}

// 卡片列表
export async function getLogProjectCardList(params: LogProjectParams) {
  return request('/api/v2/project/log/search_my_card_log_list', {
    method: 'post',
    data: params
  })
}

interface SaveLogRequest {
  log: log.ILogParamsType
  is_draft: boolean
}
// 写log
export async function SaveLog(params: SaveLogRequest) {
  return request('/api/v2/project/log/save', {
    method: 'post',
    data: params
  })
}

interface ICreateLogProjectRequest {
  log: log.ILogParamsType
  project: {
    alias: string
    company_name: string
    name: string
    logo: string
    id_qmp: string
  }
  is_draft: boolean
}
// 新建项目
export async function createLogProject(params: ICreateLogProjectRequest) {
  return request('/api/v2/project/log/create_log_project', {
    method: 'post',
    data: params
  })
}

interface IGetLogDetailRequest {
  id: number
  project_id: number
  is_need_draft?: number
  log_type: number
}
// 获取log详情
export async function getLogDetail(params: IGetLogDetailRequest) {
  return request('/api/v2/project/log/get', {
    method: 'get',
    data: params
  })
}

interface IDeleteLogRequest {
  log_id?: number
}
/** 删除 Log（仅 admin） */
export async function deleteLog(params: IDeleteLogRequest) {
  return request('/api/v2/project/log/delete', {
    method: 'post',
    data: params
  })
}

interface IDelLogDraftRequest {
  id?: number
  log_type?: number
  project_id?: number
}
// 删除log草稿
export async function delLogDraft(params: IDelLogDraftRequest) {
  return request('/api/v2/project/log/delete_log_draft', {
    method: 'post',
    data: params
  })
}
interface IGetProjectLogDraftRequest {
  id?: number
  log_type?: number
  project_id?: number
}
// 获取创建项目及log的草稿
export async function getProjectLogDraft(params: IGetProjectLogDraftRequest) {
  return request('/api/v2/project/log/get_log_project_draft', {
    method: 'get',
    data: params
  })
}

interface IDelProjectLogDraftRequest {
  log_type: number
}
// 删除创建项目及log的草稿
export async function delProjectLogDraft(params: IDelProjectLogDraftRequest) {
  return request('/api/v2/project/log/delete_log_project_draft', {
    method: 'post',
    data: params
  })
}

export interface IGetProjectUserLogRequest {
  project_id: number
}
// 写log人员列表
export async function getProjectUserLog(params: IGetProjectUserLogRequest) {
  return request<CommonRes<{ list: ILogPmListType[] }>>('/api/v2/project/log/pm_list', {
    method: 'get',
    data: params
  })
}
